{
  "hero": {
    "title": "NAPAICP 參賽者操作手冊",
    "description": "從註冊帳號到查看結果，完整說明學生／參賽者在平台上的操作方式。內容只涵蓋目前平台實際已有的功能，畫面實際顯示為準。"
  },
  "quickNav": {
    "label": "頁內導覽",
    "overview": "適用對象",
    "account": "帳號與登入",
    "findCompetition": "找到競賽",
    "team": "組隊",
    "registration": "報名表單",
    "submission": "作品繳交",
    "critical": "務必先看懂的規則",
    "rounds": "初賽／決賽與晉級",
    "results": "查看結果",
    "faq": "常見問題",
    "privacy": "帳號與個資",
    "events": "活動"
  },
  "overview": {
    "heading": "適用對象",
    "description": "本手冊適用於以學生／參賽者身分使用平台的使用者：報名競賽、組隊、填寫表單、上傳與提交作品。若您是評審，請見評審操作手冊；若您是主辦方，請見主辦方操作手冊。"
  },
  "account": {
    "heading": "帳號與登入",
    "steps": {
      "register": {
        "title": "1. 註冊帳號",
        "description": "以 Email 與密碼註冊帳號。系統會寄送驗證信到您填寫的 Email，完成驗證前無法使用需要登入的功能。"
      },
      "verifyEmail": {
        "title": "2. 完成 Email 驗證",
        "description": "點擊驗證信中的連結完成驗證。若沒收到信，請確認垃圾郵件匣，或使用忘記密碼流程重新觸發相關信件。"
      },
      "login": {
        "title": "3. 登入 / 登出",
        "description": "以已驗證的 Email 與密碼登入；若登入頁顯示「使用 Google 帳號登入」按鈕，也可以直接用 Google 帳號登入，實際可用方式以登入頁顯示為準。"
      },
      "forgotPassword": {
        "title": "4. 忘記密碼",
        "description": "在登入頁使用「忘記密碼」，系統會寄送重設密碼連結；完成重設密碼後，先前的登入狀態會失效，需要重新登入。"
      },
      "manageAccount": {
        "title": "5. 管理帳號與個資",
        "description": "在右上角帳號選單開啟「帳號與安全」，可修改密碼、變更 Email（需驗證目前密碼；變更需點擊寄送到新地址的驗證連結才會生效）、查看並登出已登入裝置。同一頁的「資料匯出與帳號刪除」區塊可下載一份平台持有您所有資料的 JSON 檔，或申請刪除帳號（需驗證目前密碼）；申請送出後會排入平台管理員的審核佇列，經核准後您的姓名、Email 等識別資訊會被匿名化並永久刪除登入憑證，但作品、評分等歷史競賽紀錄會保留但匿名化，此操作無法復原。"
      }
    }
  },
  "findCompetition": {
    "heading": "找到競賽與查看資格",
    "description": "未登入即可在首頁或競賽列表瀏覽目前公開中的競賽，查看競賽簡介、時程與資格條件；確定符合資格後再登入報名。每場競賽的公開頁面網址是獨立的，可以直接分享給他人。",
    "sub": {
      "list": {
        "heading": "競賽列表",
        "description": "首頁與競賽列表會列出目前公開狀態中的競賽；每張卡片顯示名稱、簡介與目前所屬階段（例如報名中、投稿中），點擊即可進入該場競賽的公開詳情頁。"
      },
      "detail": {
        "heading": "競賽詳情頁",
        "description": "詳情頁包含競賽簡介、完整時程（含各輪次的報名／投稿／評審區間）、報名資格條件；未登入也能完整閱讀，登入後畫面會依您目前的參賽狀態顯示對應的下一步操作按鈕。"
      },
      "eligibility": {
        "heading": "確認參賽資格",
        "description": "報名前請先在詳情頁確認資格條件，包含隊伍人數上限／下限與是否需要指導教師。部分條件由系統在您實際操作時擋下（例如隊伍已達人數上限時，新的邀請連結會無法加入），但並非所有條件都有系統層級的攔截，建議先核對過條件再進行報名。"
      },
      "competitionInfo": {
        "heading": "競賽資訊（總覽頁）",
        "description": "登入並進入該場競賽的參賽者工作區後，左側導覽會有一個「競賽資訊」頁籤，將原本分散在各處的資訊彙整成一頁：完整賽程（含每一輪的報名／繳交／評審時間區間，而不只是下一個里程碑）、該場競賽的公告列表，以及主辦方填寫的參賽資格、投稿規定、評選標準、獎項、主辦單位聯絡方式與常見問答等說明文字（皆為選填，主辦方沒填寫的區塊不會顯示）。公告只會顯示您依目前身分可見的範圍，不會出現僅限評審或工作人員查看的公告。若該場競賽未開放公開頁面或已封存，說明文字區塊可能無法取得，此時該區塊會直接省略，不會顯示錯誤。\n\n主辦方也可能把重要公告以 Email 寄給您（信末會註明為競賽官方通知，並附上主辦單位聯絡信箱），但公告的完整內容一律可以在這個頁面查看。"
      }
    }
  },
  "team": {
    "heading": "組隊",
    "steps": {
      "create": {
        "title": "1. 建立隊伍",
        "description": "在符合報名時程的競賽中建立隊伍，通常建立者即為隊長。"
      },
      "invite": {
        "title": "2. 透過邀請連結邀請隊員",
        "description": "隊長可產生邀請連結分享給預定的隊員，隊員需以自己的帳號登入並開啟連結加入。"
      },
      "join": {
        "title": "3. 加入隊伍",
        "description": "開啟隊友傳給你的邀請連結後，系統會先顯示競賽、團隊與邀請者資訊。若尚未登入，先登入或建立帳號，完成後系統會帶你回到邀請頁。確認資訊無誤後，選擇「接受邀請並加入」即可完成加入；開啟邀請連結本身不會直接把你加入團隊。加入成功後，選擇「進入競賽」繼續完成參賽任務。如果邀請已過期或失效，請向團隊隊長索取新的邀請連結。如果你已加入這場競賽的另一個團隊，必須先處理目前的團隊關係，才能接受其他團隊的邀請。"
      },
      "roles": {
        "title": "4. 隊長與隊員的差異",
        "description": "隊長通常可管理隊伍資料與成員；一般隊員可查看與協作填寫表單，實際可操作項目以畫面顯示為準。"
      },
      "editInfo": {
        "title": "5. 編輯隊伍資料",
        "description": "隊伍資料可在報名期間或該場競賽允許的期間內編輯；作品正式提交後，隊伍異動可能受到限制（見下方「務必先看懂的規則」）。"
      },
      "advisor": {
        "title": "6. 指導教師資料",
        "description": "若該場競賽要求填寫指導教師資訊，請於隊伍或報名表單中一併填寫。"
      }
    }
  },
  "registration": {
    "heading": "填寫報名表單",
    "description": "登入且在報名開放期間內，依競賽要求填寫報名表單。表單欄位、是否必填由主辦方設定，可能隨版本更新而調整。",
    "sub": {
      "fill": {
        "heading": "填寫報名資料",
        "description": "在競賽詳情頁的「報名資料」區塊填寫主辦方設定的欄位（必填欄位標有紅色星號）。有些欄位只在特定選項下才會出現，例如選擇「參賽組別」之後，才會出現該組別專屬的欄位；切換選項時，不再適用的欄位會被隱藏，先前為它填的答案也會被清除，需要在新的選項下重新填寫。表單會在您填寫時自動儲存，儲存成功時畫面會顯示「已自動儲存」與時間；但系統只在所有必填欄位都已填妥時才會儲存，若還有必填欄位未完成，畫面會提示「尚有必填欄位未完成，填寫完成後會自動儲存」，此時尚未存入任何內容。當所有必填欄位都已填妥並儲存成功，報名資料即視為已送出；您也可以隨時自行按下畫面上的按鈕儲存。"
      },
      "complete": {
        "heading": "完成報名",
        "description": "所有必填欄位填妥後，系統會自動儲存，您也可以點擊「確認並完成報名」立即完成；若還有必填欄位未完成，畫面會標示缺漏的欄位。必填的勾選框（例如「團隊聲明」）必須勾選才算填妥，沒有勾選就無法完成報名。第一次成功完成報名時，畫面會顯示明確的完成狀態轉場。"
      },
      "edit": {
        "heading": "修改已完成的報名",
        "description": "報名完成後，該區塊預設顯示已完成的摘要；點擊「查看／修改報名資料」可重新開啟表單，此時按鈕文字會變成「儲存變更」。報名資料本身沒有像作品投稿一樣的鎖定機制，在報名期間內可以隨時回來修改並重新儲存；報名截止後就無法再儲存或修改，畫面會顯示「報名時間已截止」。報名截止時間以競賽頁「下一個里程碑」與賽程顯示的日期為準，並且是目前輪次的報名截止時間；主辦方延長報名時間後，這些日期會跟著更新。"
      },
      "needsUpdate": {
        "heading": "報名資料顯示「需補填」時怎麼辦",
        "description": "報名完成之後，主辦方可能修改報名表單（例如新增必填欄位），或您先前存下的答案不符合目前表單的必填規則（例如必填的「團隊聲明」是未勾選的狀態）。這時系統不會取消您的報名，但會在三個地方提醒您：（1）競賽頁的「報名資料」卡片顯示「需補填」與「尚需補填：…」，並提供「補填報名資料」按鈕；（2）「我的競賽」卡片顯示「報名資料需補填：…」，進度列的報名項目會顯示為「報名（需補填）」；（3）首頁「我的下一步」多出一項「補填報名資料」。處理方式：點擊「補填報名資料」，補上缺少的欄位（勾選「團隊聲明」、選擇新增的必填選項等），再按「儲存變更」；儲存成功後，「需補填」的標示就會消失。請在報名截止前完成，截止後無法再修改。這個標示只是提醒，不會改變您在團隊或作品繳交上的進度；系統也不會替您勾選任何聲明，聲明必須由您本人確認。主辦方也可能寄「報名資料需補填」的提醒信給您，信中會列出缺少的欄位與補填連結。"
      },
      "eligibility": {
        "heading": "學生資格驗證與在學證明（若競賽有要求）",
        "description": "若該場競賽的主辦方開啟了「學生資格驗證」政策，「參賽資訊」摘要區塊會另外顯示團隊資格驗證完成度磚（例如「1 / 2 位必要成員已完成資格驗證」），點擊可前往獨立的「學生資格驗證」頁面。您可在該頁上傳／重新上傳在學證明（在學證明書、學生證或其他經主辦方核准的文件），支援 PDF、PNG、JPG、JPEG 格式，單一檔案最大 10 MB，並查看目前狀態：尚未提交、審核中、已通過、未通過（含退回原因）或已過期；審核由該場競賽的主辦方（Competition Admin）人工進行，系統不會自動通過。已有審核中證明時，點擊「重新上傳」展開的表單會自動帶入您目前的證明類型、學校、系所、學號，不需要重新輸入一次，只更換檔案或一併修改資料皆可；若中途不想繼續，點擊「取消」即可放棄本次編輯並收合表單，不會影響原本已送出、正在審核中的證明。資格驗證狀態不會影響報名是否完成：即使尚未通過驗證，「確認並完成報名」也不會被擋下；資格驗證是與報名完全獨立的另一條進度，兩者互不影響。您上傳的原始證明檔案只有您本人與該場競賽具審核權限的主辦方看得到；隊友只能看到您的狀態標籤，看不到證明內容或退回原因。依平台的資料保存政策，原始證明檔案會在該場競賽結束滿 365 天後自動永久刪除，僅保留審核結果（通過／未通過與時間）供日後查核，檔案本身無法復原。"
      }
    }
  },
  "submission": {
    "heading": "作品繳交",
    "helpCta": "操作：如何正式提交作品",
    "helpTroubleshootingCta": "疑難排解：無法正式提交作品",
    "sub": {
      "requirements": {
        "heading": "查看投稿要求",
        "description": "目前沒有獨立的「投稿要求」頁面；投稿規則與注意事項是由主辦方以說明文字／標題欄位直接寫進作品繳交表本身，開啟繳交表後從上到下閱讀即可看到，個別欄位下方也會顯示該欄位專屬的補充說明文字。"
      },
      "fillForm": {
        "heading": "1. 填寫作品繳交表",
        "description": "依主辦方設定的欄位填寫作品說明；未正式提交前的內容都是草稿狀態，可以持續修改。若表單有「網址」欄位（例如影片繳交網址），評審會在評分頁看到你填的網址，因此請確認：影片使用 YouTube（不公開）或 Vimeo，評審可直接在頁內播放；Google Drive 等雲端硬碟請把分享權限設為「知道連結的任何人都能檢視」，並在評審結束前不要修改或撤銷，否則評審可能打不開；若為匿名評審，請勿在內容或分享帳號中露出隊名、校名或可辨識身分的資訊。填完後建議用無痕視窗自己開一次，確認不需登入就能看到。"
      },
      "uploadFiles": {
        "heading": "2. 上傳／更換／刪除檔案",
        "description": "上傳作品檔案，若檔案格式或大小不符合限制，畫面會顯示具體的錯誤訊息。上傳成功的檔案在正式提交前都可以更換或刪除；每個已上傳檔案旁會顯示「線上預覽」（主要動作，可預覽的檔案類型）與「下載」，方便上傳後直接確認內容是否正確。若上傳過程中途失敗（例如網路中斷），該欄位會明確顯示「上傳失敗，請重新上傳」，而不會被誤判為尚未填寫；請重新選擇檔案再上傳一次即可。若主辦方將多個欄位設定為同一個命名區塊，這些欄位在此頁會顯示為同一個區塊標題底下的一組欄位，方便您依區塊檢查是否都已完成。"
      },
      "review": {
        "heading": "3. 檢查投稿內容",
        "description": "正式提交前，請完整檢查表單內容與已上傳的檔案是否正確、完整。"
      },
      "markReady": {
        "heading": "4. 標記為就緒",
        "description": "確認內容無誤後點擊「標記為就緒」，狀態由草稿變更為就緒；就緒狀態下仍可編輯，也可以隨時點「退回草稿」改回草稿狀態。「正式提交」按鈕只有在狀態為就緒時才會啟用。"
      },
      "submit": {
        "heading": "5. 正式提交",
        "description": "狀態為就緒後，執行正式提交。提交成功後畫面會有明確的成功狀態顯示，作品進入正式提交（Submitted）狀態。"
      },
      "update": {
        "heading": "提交後如何更新投稿",
        "description": "作品進入正式提交（Submitted）狀態後，學生本人無法自行編輯或重新提交。具權限的主辦方／工作人員可在管理後台的投稿詳情頁點擊「解鎖」或「退回修正」（皆須填寫理由）：兩者都會把您的作品改回「已就緒」讓您可以重新編輯，差別在於「退回修正」會額外寄信通知隊伍中的非指導老師成員說明需要修改的原因，「解鎖」則不會寄信。若您的作品需要修改，請先聯絡該場競賽的主辦方協助處理。作品被退回修正後，「作品繳交」頁面本身也會顯示「需要修正作品」的提示區塊並附上主辦方填寫的具體原因（「原因：⋯」），不需要只依賴信件內容。一旦狀態被改回已就緒，您就能像先前一樣重新編輯並再次正式提交；先前已提交的版本會保留在歷史紀錄中，不會被悄悄覆蓋。"
      }
    }
  },
  "critical": {
    "heading": "務必先看懂的規則",
    "description": "以下規則會直接影響您能不能順利完成報名與提交，請務必先讀過：",
    "items": {
      "oneTeam": "同一場競賽中，非 teacher 身分的帳號最多只能有一個有效的隊伍身分，不能同時加入多個隊伍。",
      "draftVsSubmit": "填寫作品繳交表、上傳檔案都只是「草稿」狀態，不等於已經完成報名或繳交，一定要執行「正式提交」，作品才會被視為正式參賽版本。",
      "uploadNotSubmit": "檔案上傳成功不等於已正式提交。上傳只是把檔案放進草稿；沒有點擊正式提交，主辦方與評審都看不到您的作品。",
      "frozenAfterSubmit": "正式提交後，該次提交的內容會被凍結為一個版本；如果之後平台開放重新提交或修正，新的操作會依主辦方規則產生新的版本，而不是悄悄覆蓋掉原本已提交的內容。",
      "deadlineTime": "畫面上顯示的截止時間一律以台北時間（UTC+08:00）顯示，與您裝置所在的時區無關；如有疑慮建議提早完成提交，不要卡在截止時間前最後一刻才操作。",
      "teamChangeLimit": "作品正式提交後，隊伍成員的異動可能會受到限制；實際上是否還能編輯，請以畫面當下是否顯示對應操作按鈕為準。",
      "resultsHidden": "在主辦方正式公布結果之前，您看不到評審姓名、評分明細或其他隊伍的私人資料；結果公布的時間點由主辦方決定。",
      "whoCanSubmit": "隊伍中任何非指導教師的有效成員都能填寫草稿、上傳檔案並執行正式提交，沒有「只有隊長才能正式提交」的額外限制；指導教師（teacher）可以檢視作品內容，但無法編輯或提交。"
    }
  },
  "rounds": {
    "heading": "初賽／決賽與晉級",
    "description": "部分競賽分為初賽與決賽兩個階段，各自有獨立的報名／繳交／評審時程。只有經主辦方明確晉級的隊伍才能建立決賽的正式提交；是否晉級與晉級名單由主辦方公告。"
  },
  "results": {
    "heading": "查看評分與結果",
    "description": "在您的隊伍頁面（「我的隊伍」）有「我的結果」區塊，可查看自己隊伍的結果，但需同時符合兩個條件：主辦方已將該場競賽的結果查看範圍開放給參賽者（而非設為僅主辦方可見），且該輪次／組別的結果已正式公布（僅計算或鎖定尚不算，仍會顯示為尚無結果）。畫面只會顯示您自己隊伍的分數、名次與獎項等第，看不到其他隊伍的任何資料。若主辦方尚未開放查看，畫面會清楚顯示「請洽主辦方」而非嘗試顯示分數；若您的作品因評審人數不足未達計算門檻，會顯示「未達評分門檻，未列入本次結果排名」，而非顯示錯誤的分數。若該輪次由工作人員輸入加分或扣分，結果會另列「評審平均」與「工作人員輸入調整」，並逐項列出加分與扣分名稱。若您的隊伍被主辦方取消資格，結果頁與繳交頁會顯示取消資格提示，且無法再開始或修改任何輪次的繳交（取消資格以隊伍為單位，跨輪次生效）；主辦方可復原，復原時隊伍會收到通知，請與主辦方聯絡。"
  },
  "faq": {
    "heading": "常見問題與錯誤排除",
    "items": {
      "emailNotVerified": {
        "q": "登入時顯示帳號尚未驗證怎麼辦？",
        "a": "請先至註冊時填寫的 Email 信箱查看驗證信並完成驗證；找不到信件可嘗試忘記密碼流程重新觸發相關信件寄送。"
      },
      "inviteExpired": {
        "q": "隊伍邀請連結顯示失效或無法加入？",
        "a": "邀請連結可能已過期或已被使用；請聯絡隊長重新產生一個新的邀請連結。"
      },
      "alreadyInTeam": {
        "q": "無法加入新隊伍，顯示已加入其他隊伍？",
        "a": "同一場競賽中每個帳號最多只能有一個有效隊伍身分；如需更換隊伍，請先確認原隊伍狀態，或聯絡主辦方協助處理。"
      },
      "missingField": {
        "q": "送出表單時顯示缺少必填欄位？",
        "a": "畫面會標示出哪個欄位未填寫或格式不符，請依提示補齊後再重新送出。"
      },
      "fileRejected": {
        "q": "上傳檔案被拒絕？",
        "a": "請確認檔案格式與檔案大小是否符合該欄位顯示的限制說明；不符合限制的檔案會在上傳當下被拒絕並顯示原因。"
      },
      "pastDeadline": {
        "q": "已過截止時間，還能提交嗎？",
        "a": "截止時間一到，系統會拒絕新的正式提交；若有特殊情況，需由主辦方依平台提供的延期機制處理，學生本身無法自行延長截止時間。"
      },
      "needsUpdate": {
        "q": "看到「報名資料需補填」怎麼辦？",
        "a": "表示您已儲存的報名答案不符合目前表單的必填規則，例如新增了必填欄位，或必填的「團隊聲明」沒有勾選。請進入競賽頁，點擊「報名資料」卡片的「補填報名資料」，補上缺少的欄位後按「儲存變更」；請在報名截止前完成。詳見本手冊「報名」章節的「報名資料顯示需補填時怎麼辦」。"
      },
      "registrationDeadline": {
        "q": "報名截止時間要怎麼看？",
        "a": "以競賽頁的「下一個里程碑」與賽程顯示的日期為準，並且是目前輪次的報名截止時間；主辦方延長報名時間後，這些日期會跟著更新。截止後無法再儲存或修改報名資料。"
      },
      "submissionWhileRegistrationOpen": {
        "q": "報名還沒截止，可以開始繳交作品嗎？",
        "a": "可以，只要主辦方設定的作品繳交時間已經開始。報名與作品繳交的時間可以重疊，在重疊期間，競賽狀態會顯示為「報名中」，但已完成報名與團隊設定的隊伍仍然可以開始或繼續準備作品，畫面不會因此顯示「作品繳交已截止」。實際的繳交截止時間以競賽頁與作品繳交頁顯示的日期為準。"
      },
      "officialEmail": {
        "q": "收到主辦方的 Email 通知，要怎麼確認是真的？",
        "a": "平台寄出的通知信，主旨與信頭都會標示 NAPAICP 競賽平台；平台自動產生的連結（例如補填報名資料的連結）都指向 aicp.ntpu.ai。公告與提醒類的信件末尾會註明這是競賽官方通知，並附上主辦單位的聯絡信箱；公告內文中的其他連結則是主辦方自己放入的，請自行判斷。平台不會在信中要求您提供密碼或其他機密資料。若對信件有疑慮，請不要點信中的連結，改為直接開啟 https://aicp.ntpu.ai 登入確認，或寫信到信中的主辦單位聯絡信箱詢問。"
      }
    }
  },
  "privacy": {
    "heading": "帳號與個資注意事項",
    "description": "您的帳號資料、隊伍資料與作品內容只會提供給有權限的評審（僅限被指派的作品）與該場競賽的主辦方，不會顯示給其他參賽隊伍。個資蒐集與使用範圍、資料保存原則，請見隱私權說明與資料保存政策。"
  },
  "cta": {
    "heading": "還有其他問題？",
    "howtoCta": "回到快速開始",
    "privacyCta": "隱私權說明"
  },
  "events": {
    "heading": "活動服務（接駁車、餐飲與客服）",
    "description": "除了競賽，平台也提供活動頁（主導覽「活動」，例如 /events/taai-2026），提供研討會的補充服務。報名、付款與宴會資格一律以官方 TAAI 報名系統為準。活動服務與競賽身分無關，不需要參賽也能使用。",
    "items": [
      {
        "title": "免費接駁車預約",
        "description": "在活動頁最上方按「免費接駁車線上預約」（/events/:slug/shuttle）。可只用 Email 預約（寄確認連結，30 分鐘內開啟才保留座位），或登入後預約；第一次需填乘車聯絡資料（真實姓名必填）。每人每天每方向一筆預約，可附最多 3 位同行者，每人各有乘車 QR。額滿可候補，有人取消會自動遞補並 Email 通知。預約與取消於發車前 12 小時截止。"
      },
      {
        "title": "班次代碼怎麼看",
        "description": "三位數字像高鐵車次：第 1 碼日期（1 = 11/20，2 = 11/21），第 2 碼出發站，第 3 碼到達站；1 = 臺北大學站，2 = 板橋高鐵站，3 = 會場。例如 113 是第一天臺北大學站往會場，132 是第一天會場往板橋高鐵站。時間一律為台灣時間 (UTC+08:00)。"
      },
      {
        "title": "我的接駁車",
        "description": "查看登機證式卡片與乘車 QR、候補順位，可取消預約、加入行事曆（.ics，不含 QR），也可選擇在發車前 24 小時內收 Email 提醒（預設關閉）。上車時向工作人員出示 QR，請勿轉傳。"
      },
      {
        "title": "餐飲與宴會回覆",
        "description": "登入後在「餐飲與宴會」回覆午餐出席與飲食類別（備註 200 字內、加密儲存），並回覆是否出席宴會。宴會回覆只供估算人數，不是資格或付款證明。截止時間以頁面倒數為準，截止後無法修改。"
      },
      {
        "title": "客服與協助、公告",
        "description": "在「客服與協助」選類別送出案件並追蹤狀態（新案件、處理中、已解決、已結案），只看得到自己的案件。人身安全緊急狀況請直接撥 119 或 110。活動頁的「最新公告」有一般、重要、緊急三種。"
      },
      {
        "title": "個資與保存",
        "description": "乘車資料僅用於接駁異動與現場核對：驗票人員只見姓名、單位、職稱，行動電話加密且僅活動 owner 在緊急時可看（有紀錄）。餐飲、乘車聯絡與提醒資料於活動結束後 30 天自動刪除。"
      }
    ],
    "links": [
      {
        "to": "/help/reference/events-overview",
        "label": "活動平台總覽"
      },
      {
        "to": "/help/student/book-event-shuttle",
        "label": "如何預約活動接駁車"
      },
      {
        "to": "/help/student/event-meals-and-help-desk",
        "label": "如何回覆餐飲宴會與使用客服"
      },
      {
        "to": "/help/troubleshooting/event-shuttle-booking-failed",
        "label": "無法預約活動接駁車"
      }
    ]
  }
}
